import React, {useEffect} from "react";
import {INodeToAdd} from "../../ImageViewerHandlers/Hierarchy/NodeToAdd";
import {useKHExtBlackboard} from "../../../contexts/KHExtensionsContext/KHExtensionsContext";

export function BufferBlackboardSync({buffer}: {buffer: ReadonlyArray<INodeToAdd>}) {
    const blackboard = useKHExtBlackboard();
    useEffect(() => {
        blackboard.set("hierarchy/add_multiple_nodes_buffer", buffer);
    }, [buffer]);
    return (
        <></>
    );
}